import { render, staticRenderFns } from "./NotificationsDropdownItem.vue?vue&type=template&id=2e03f832&scoped=true&"
import script from "./NotificationsDropdownItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationsDropdownItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsDropdownItem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NotificationsDropdownItem.vue?vue&type=style&index=1&id=2e03f832&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e03f832",
  null
  
)

export default component.exports